import qs from 'qs';
import { _axios } from '@/plugins/axios';
import { API_PATH } from './constants';

export const createArticle = (token, parmas) => {
  const apiPath = API_PATH.apiPartner + API_PATH.articles;
  const data = Object.create(null);
  Object.entries(parmas).forEach(([key, value]) => (data[key] = value));
  return _axios.post(apiPath, qs.stringify(data), {
    headers: {
      'X-Line-Biz-Session': token,
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
  });
};

export const createArticleFromTemporary = (token, temporaryArticleId) => {
  const apiPath = API_PATH.apiPartner + API_PATH.temporaryArticleToArticle;
  return _axios.post(`${apiPath}/${temporaryArticleId}`, null, {
    headers: {
      'X-Line-Biz-Session': token
    }
  });
};

export const relateToArticle = (token, articleId, parentArticleId) => {
  const apiPath = API_PATH.apiPartner + API_PATH.articleRelatToOtherArticle;
  return _axios.put(apiPath, null, {
    headers: {
      'X-Line-Biz-Session': token
    },
    urlParams: {
      articleId,
      parentArticleId
    }
  });
};
